import { render, staticRenderFns } from "./CRMCarAdmin.vue?vue&type=template&id=54b936c2&scoped=true&"
import script from "./CRMCarAdmin.vue?vue&type=script&lang=js&"
export * from "./CRMCarAdmin.vue?vue&type=script&lang=js&"
import style0 from "./CRMCarAdmin.vue?vue&type=style&index=0&id=54b936c2&scoped=true&lang=css&"
import style1 from "./CRMCarAdmin.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54b936c2",
  null
  
)

export default component.exports